import { CellContext } from "@tanstack/react-table"

import { UITypes } from "types"

import {
  PriorityBadge,
  type PriorityBadgeVariant,
} from "pages/contractor/IntelligenceReportsPage/components/PriorityBadge"

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const IntelligenceReportsPriorityCell = ({ cell }: Props) => {
  const value = cell.getValue()?.value ? String(cell.getValue().value) : ""
  const normalized = value.toLowerCase()
  const variant: PriorityBadgeVariant = normalized === "high" ? "high" : normalized === "medium" ? "medium" : "low"

  return <PriorityBadge variant={variant}>{value || "-"}</PriorityBadge>
}
